const DAY = 86400000;

export function planningContext(search = "") {
  const params = new URLSearchParams(search);
  const from = params.get("von");
  const employeeId = params.get("mitarbeiterId");
  const mandateId = params.get("mandatId");
  if (!from || !/^\d{4}-\d{2}-\d{2}$/.test(from)) return { employeeId, mandateId, from: null, to: null };
  const start = new Date(`${from}T00:00:00Z`);
  if (Number.isNaN(start.valueOf())) return { employeeId, mandateId, from: null, to: null };
  return { employeeId, mandateId, from, to: new Date(start.valueOf() + 6 * DAY).toISOString().slice(0, 10) };
}

export const inContext = (record, context) =>
  (!context.employeeId || record.mitarbeiterId === context.employeeId) &&
  (!context.mandateId || record.mandatId === context.mandateId) &&
  (!context.from || (record.datum >= context.from && record.datum <= context.to));

export const absenceInContext = (absence, context) =>
  (!context.employeeId || absence.mitarbeiterId === context.employeeId) &&
  (!context.from || (absence.bis >= context.from && absence.von <= context.to));

export function datesInContext(items, context) {
  if (!context.from) return [];
  return items.filter(item => item.datum >= context.from && item.datum <= context.to);
}
